import React, { useState, useEffect } from 'react';
import { Link, useNavigate, NavLink, useLocation } from 'react-router-dom';
import homeicon from '../assets/images/Home.svg';
import notificationsicon from '../assets/images/Notifications.svg';
import messageicon from '../assets/images/Messages.svg';
import collectionicon from '../assets/images/Collections.svg';
import subscriptionicon from '../assets/images/Subscriptions.svg';
import addcardicon from '../assets/images/Add_card.svg';
import profileicon from '../assets/images/profile.svg';
import moreicon from '../assets/images/More.svg';
import collection_popupicon from '../assets/images/Collections_b.svg';
import settingsicon from '../assets/images/Settings.svg';
import youcardicon from '../assets/images/Your_сards.svg';
import becomecreatoricon from '../assets/images/Become_a_creator.svg';
import supporticon from '../assets/images/Help_and_support.svg';
import addpostmobile from '../assets/images/add_post.svg';
import darkmodeicon from '../assets/images/Dark_mode.svg';
import logouticon from '../assets/images/Log_out.svg';
import config from '../config/config';

const ModalOverlay = ({ show, onClick }) => {
  return show ? <div className="modal-backdrop fade show" onClick={onClick}></div> : null;
};

const MainSidebar = () => {
  const [showModal, setShowModal] = useState(false);
  const [userDetails, setUserDetails] = useState({
    user: {},
    user_details: {},
  });
  const [followersCount, setFollowersCount] = useState(0);
  const [fansCount, setFansCount] = useState(0);
  const [unreadMessageCount, setUnreadMessageCount] = useState(0);
  const [notificationCount, setNotificationCount] = useState(0);
  const location = useLocation();
  const path = location.pathname;
  const navigate = useNavigate();

  const handleShow = () => {
    setShowModal(true);
    document.body.classList.add('sidebarmenuopen');
  };

  const handleClose = () => {
    setShowModal(false);
    document.body.classList.remove('sidebarmenuopen');
  };

  const handleLogout = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        console.error('No token found in localStorage');
        return;
      }
  
      const response = await fetch(`${config.baseURL}/logout`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
  
      const data = await response.json();
  
      if (response.ok) {
        // Clear session-related data from localStorage
        localStorage.removeItem('token');
        localStorage.removeItem('userRole');
        localStorage.removeItem('userData');  // Example: Add user data or any other session-related items
        navigate('/login');  // Redirect to the login page after logout
      } else {
        console.error('Logout failed:', data.message || 'Unknown error');
      }
    } catch (error) {
      console.error('Logout error:', error);
    }
  };
  
  // Function to handle 401 error
  const handleAuthError = (response) => {
    if (response.status === 401) {
      handleLogout(); // Logout user if 401 is encountered
    }
    return response; // Continue if it's not a 401 error
  };





  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem('token');

        // Fetch user details
        const userDetailsResponse = await fetch(`${config.baseURL}/current-user-details`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (userDetailsResponse.ok) {
          const data = await userDetailsResponse.json();
          setUserDetails({
            user: data.data.user,
            user_details: data.data.user_details,
          });
        } else {
          console.error('Failed to fetch user details');
        }

        // Fetch notification count
        const notificationResponse = await fetch(`${config.baseURL}/users-unread-notification`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (notificationResponse.ok) {
          const data = await notificationResponse.json();
          setNotificationCount(data.unread_notifications_count);
          setUnreadMessageCount(data.unread_messages_count);
        } else {
          console.error('Failed to fetch notification count');
        }

        // Fetch followers count
        const followersResponse = await fetch(`${config.baseURL}/following-users`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (followersResponse.ok) {
          const data = await followersResponse.json();
          setFollowersCount(data.total_count || 0);
        } else {
          console.error('Failed to fetch followers count');
        }

        // Fetch fans count
        const fansResponse = await fetch(`${config.baseURL}/fans-users-count`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (fansResponse.ok) {
          const data = await fansResponse.json();
          setFansCount(data.total_count || 0);
        } else {
          console.error('Failed to fetch fans count');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);


  const isCollection = path.includes('collection');

  // Check if the URL matches 'fans', 'restricted', 'blocked', or starts with '/user-list'
  const isSpecialPage = (
    path === '/fans' ||
    path === '/restricted' ||
    path === '/blocked' ||
    path.startsWith('/user-list')
  );
  const isMessagesPage = path.includes('/Chat') || path.includes('/chatmessage');
  return (   

    <div>
    <div className="mobile_wrap_footer">


      <div className="home_icon_mobile">

           <div className="left_nav_bar_main">
            <ul> 
              <li>
              <NavLink 
                to="/home" 
                className="svg_menu_link"                
              >
                <div className="svg_menu">
                  <img src={homeicon} alt="Home Icon" />
                </div>
              </NavLink>
            </li>
             </ul>   
         </div>
      </div>

      <div className="notification_icon_mobile">
        <div className="left_nav_bar_main">
            <ul> 
              <li>
              <NavLink 
                to="/notifications" 
                className="svg_menu_link" 
                activeClassName="active_menu"
              >
                <div className="svg_menu">
                  <img src={notificationsicon} alt="Notifications Icon" />
                  {notificationCount > 0 && (
                    <span className="countdown">{notificationCount}</span>
                  )}
                </div>                
              </NavLink>
            </li>
             </ul>   
         </div>
      </div>         

      {userDetails.user.role !== 'user' && (
        <div className="create_post_mobile">
          <a className="new_post_btn2" href="/create-post">
            <span>
              <img src={addpostmobile} alt="" />
            </span>
          </a>
        </div>
      )}

      <div className="chat_icon_mobile">
        <div className="left_nav_bar_main">
            <ul> 
              <li>
              <NavLink 
  to="/Chat" 
  className="svg_menu_link" 
  activeClassName="active_menu"
>
  <div className="svg_menu">
    <img src={messageicon} alt="Messages Icon" />
    {unreadMessageCount > 0 && (
      <span className="countdown">{unreadMessageCount}</span>
    )}
  </div>
</NavLink>

                </li>
             </ul>   
         </div>
      </div>

      <div className="profile_icons">
        <a onClick={handleShow} href="javascript:void(0)" className="profile_with_text">
          {userDetails && userDetails.user_details ? (
            userDetails.user_details.user_profile ? (
              <img src={userDetails.user_details.user_profile} alt="User Profile" className="profile_image_sidebar" />
            ) : (
              userDetails.user && userDetails.user.name ? (
                userDetails.user.name.split(' ').map(part => part.charAt(0)).join('')
              ) : ''
            )
          ) : ''}
        </a>
      </div>

    </div> 

    <div className="nav_menu_side">   
      <div className="profile_icons">
        <a onClick={handleShow} href="javascript:void(0)" className="profile_with_text">
          {userDetails && userDetails.user_details ? (
            userDetails.user_details.user_profile ? (
              <img src={userDetails.user_details.user_profile} alt="User Profile" className="profile_image_sidebar" />
            ) : (
              userDetails.user && userDetails.user.name ? (
                userDetails.user.name.split(' ').map(part => part.charAt(0)).join('')
              ) : ''
            )
          ) : ''}
        </a>
      </div>
      <div className="left_nav_bar_main">
          <ul>
            <li>
              <NavLink 
                to="/home" 
                className="svg_menu_link" 
                activeClassName="active_menu"
              >
                <div className="svg_menu">
                  <img src={homeicon} alt="Home Icon" />
                </div>
                Home
              </NavLink>
            </li>
            <li>
              <NavLink 
                to="/notifications" 
                className="svg_menu_link" 
                activeClassName="active_menu"
              >
                <div className="svg_menu">
                  <img src={notificationsicon} alt="Notifications Icon" />
                  {notificationCount > 0 && (
                    <span className="countdown">{notificationCount}</span>
                  )}
                </div>
                Notifications
              </NavLink>
            </li>
            <li>
            <NavLink
  to="/Chat"
  className={`svg_menu_link ${isMessagesPage ? 'active_menu' : ''}`}  // Apply active_menu conditionally
  activeClassName="active_menu"
>
  <div className="svg_menu">
    <img src={messageicon} alt="Messages Icon" />
    {unreadMessageCount > 0 && (
      <span className="countdown">{unreadMessageCount}</span>
    )}
  </div>
  Messages
</NavLink>

            </li>
           <li>

            <Link 
                  to="/collections" 
                  className={`svg_menu_link ${isSpecialPage ? 'active_menu' : ''}`}  // Add active_menu when fans, restricted, blocked, or user-list is in the URL
                >   
                <div className="svg_menu">
                  <img src={collectionicon} alt="Collections Icon" /> 
                </div>
                Collections
              </Link>
            </li>

            <li>
              <Link to="/collections"                  
                className={`svg_menu_link ${isCollection ? 'active_menu' : ''}`}  // Add active_menu when 'collection' IS in the URL
              >
                <div className="svg_menu">
                  <img src={subscriptionicon} alt="Subscriptions Icon" />
                </div>
                Subscriptions
              </Link>
            </li>
            <li>
              <NavLink 
                to="/payment-options" 
                className="svg_menu_link" 
                activeClassName="active_menu"
              >
                <div className="svg_menu">
                  <img src={addcardicon} alt="Payment Options Icon" />
                </div>
                Payment Options
              </NavLink>
            </li>
            <li>
              <NavLink 
                to="/myprofile" 
                className="svg_menu_link" 
                activeClassName="active_menu"
              >
                <div className="svg_menu">
                  <img src={profileicon} alt="Profile Icon" />
                </div>
                My Profile
              </NavLink>
            </li>
            <li>
              <a 
                onClick={handleShow} 
                href="javascript:void(0)" 
                className="svg_menu_link"
              >
                <div className="svg_menu">
                  <img src={moreicon} alt="More Icon" />
                </div>
                More
              </a>
            </li>
          </ul>
        </div>
      <div className="new_post">

   

        <a className={`new_post_btn ${userDetails.user.role === 'user' ? 'user_disable_btn' : ''}`}  href="/create-post">
          <span>
            <svg
              enableBackground="new 0 0 50 50"
              height="50px"
              id="Layer_1"
              version="1.1"
              viewBox="0 0 50 50"
              width="50px"
              xmlSpace="preserve"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
            >
              <rect fill="none" height={50} width={50} />
              <line
                fill="none"
                stroke="#ffffff"
                strokeMiterlimit={10}
                strokeWidth={4}
                x1={9}
                x2={41}
                y1={25}
                y2={25}
              />
              <line
                fill="none"
                stroke="#ffffff"
                strokeMiterlimit={10}
                strokeWidth={4}
                x1={25}
                x2={25}
                y1={9}
                y2={41}
              />
            </svg>
          </span>
          New Post
        </a>
      </div>
      
      </div>

      {/* Restore Access Modal */}
      {showModal && (
        <>
          <ModalOverlay show={showModal} onClick={handleClose} />
          <div className="modal top-right fade show" style={{ display: 'block' }} id="ProfileModel" aria-labelledby="ProfileModelLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <div className="user_profile_popup">
                    <div className="profile_image_block">
                      <div className={`profile_with_text ${userDetails?.online_status === 'online' ? 'user_online_status' : ''}`}> 
                        <Link to="/myprofile" className="my_profile_name">
                          {userDetails && userDetails.user_details && userDetails.user_details.user_profile ? (
                            <img src={userDetails.user_details.user_profile} alt="Profile" className="profile_image_popup" />
                          ) : (
                            userDetails && userDetails.user.name
                              ? userDetails.user.name.split(' ').map(part => part.charAt(0)).join('')
                              : ''
                          )}
                        </Link>
                      </div>
                      <div className="all_profile_data">
                        <div className="user_name_row">
                          <Link to="/myprofile" className="my_profile_name">
                            {userDetails ? userDetails.user.name : 'Loading...'}
                          </Link>
                        </div>
                        <div className="profile_user_name">
                          <Link to="/myprofile">
                            {userDetails ? `@${userDetails.user.user_name}` : 'Loading...'}
                          </Link>
                        </div>
                      </div>
                    </div>
                    <ul className="list_below_name">
                      <li><span>{fansCount}</span> <Link to="/fans">Fans</Link></li>
                      <li><span>{followersCount}</span> <Link to="/collections">Following</Link></li>
                    </ul>
                  </div>
                  <button type="button" className="btn-close" onClick={handleClose} aria-label="Close"></button>
                </div>
                <div className="modal-body">
                    <div className="popup_menu">
                    <ul>
                        <li>
                          <Link to="/myprofile" onClick={handleClose}>
                            <div className="svg_menu">
                              <img src={profileicon} alt=""/>
                            </div>  
                            My Profile
                          </Link>
                        </li>
                        <li>
                          <Link to="/collections" onClick={handleClose}>
                            <div className="svg_menu">
                              <img src={collection_popupicon} alt=""/>
                            </div>  
                            Collections
                          </Link>
                        </li>
                        <li>
                          <Link to="/editprofile" onClick={handleClose}>
                            <div className="svg_menu">
                              <img src={settingsicon} alt=""/>
                            </div>  
                            Settings
                          </Link>
                        </li>
                        <hr className="poup_hor_line"/>
                        <li>
                          <Link to="/payment-options" onClick={handleClose}>
                            <div className="svg_menu">
                              <img src={addcardicon} alt=""/>
                            </div>  
                            Payment Options
                          </Link>
                        </li>                      
                        <hr className="poup_hor_line"/>
                        <li>
                          <Link to="/help" onClick={handleClose}>
                            <div className="svg_menu">
                              <img src={supporticon} alt=""/>
                            </div>  
                            Help and support 
                          </Link>
                        </li>                      
                        <hr className="poup_hor_line"/>
                      <li>
  <a href="javascript:void(0)" onClick={() => { handleClose(); handleLogout(); }}>
    <div className="svg_menu">
      <img src={logouticon} alt=""/>
    </div>  
    Log out 
  </a>
</li>

                      </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
        </>
      )}   
<a
  href="/help"
  className="contact_button visible-lg has-tooltip"
  data-original-title="Help and Support"
>
  <svg
    className="g-iconc"
    width="30"
    height="30"
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M31.0053 8.85377C38.2246 21.2565 25.9764 32.0277 19.2599 35.9809C19.0794 36.0872 18.8587 35.953 18.8587 35.7436V31.2809C18.8587 31.1509 18.7633 31.0382 18.6361 31.0114C7.29625 28.6239 5.16507 21.7082 5.01664 17.9347C4.55574 6.21801 13.7833 2.00001 18.8587 2C25.7629 1.99998 29.3135 6.3542 31.0053 8.85377Z"
      stroke="#fff"
      strokeWidth="2.9386"
    />
    <path
      d="M22.0777 17.3702L22.0777 17.3702L22.0803 17.3673L23.239 16.0799C24.0138 15.24 24.5078 14.0671 24.5078 12.7788L24.5078 12.7779C24.4925 9.56423 22.0881 6.93546 19.0992 6.93546C16.4964 6.93546 14.3344 8.93134 13.8214 11.5576C13.669 12.3382 14.33 12.9537 15.0719 12.9537H15.3224C16.0866 12.9537 16.6394 12.3183 16.8973 11.6882C17.2753 10.7644 18.1214 10.1356 19.0992 10.1356C20.4215 10.1356 21.5095 11.2915 21.5095 12.7627C21.5095 13.4864 21.2312 14.1498 20.8008 14.6314C20.8005 14.6317 20.8003 14.632 20.8 14.6322L19.1818 16.4014C19.1817 16.4015 19.1817 16.4015 19.1816 16.4016C18.4627 17.1805 17.9486 18.1865 17.7308 19.3037C17.5787 20.0842 18.2394 20.6996 18.9814 20.6996H19.3359C20.1003 20.6996 20.6608 20.0769 20.7745 19.3661C20.8538 18.8707 20.9968 18.5722 21.2017 18.3039C21.3069 18.166 21.4305 18.0336 21.5776 17.8834C21.6189 17.8411 21.6623 17.7973 21.7074 17.7517C21.8207 17.6373 21.9453 17.5114 22.0777 17.3702ZM18.5167 25.6998H19.986C20.7407 25.6998 21.3525 25.088 21.3525 24.3333V23.1579C21.3525 22.4032 20.7407 21.7914 19.986 21.7914H18.5167C17.7621 21.7914 17.1503 22.4032 17.1503 23.1579V24.3333C17.1503 25.088 17.7621 25.6998 18.5167 25.6998Z"
      fill="#fff"
      stroke="#fff"
      strokeWidth="0.382018"
      strokeLinejoin="round"
    />
  </svg>
  {/* <span className="tooltip-text">Help and Support</span> */}
</a>

    </div>

  );
};

export default MainSidebar;
